import { type ReactElement } from "react"

export type ImageSource = {
  src: string
  media?: string
}

export type ResponsiveImageProps = {
  sources: ImageSource[]
  fallbackSrc: string
  alt: string
  className?: string
  pictureClassName?: string
}

export function ResponsiveImage({
  sources,
  fallbackSrc,
  alt,
  className,
  pictureClassName,
}: ResponsiveImageProps): ReactElement {
  return (
    <picture className={pictureClassName}>
      {sources.map((source, index) => (
        <source key={index} media={source.media} srcSet={source.src} />
      ))}
      <img src={fallbackSrc} alt={alt} className={className} loading="lazy" decoding="async" />
    </picture>
  )
}

// Common breakpoints used across the application
export const BREAKPOINTS = {
  mobile: "(max-width: 640px)",
  tablet: "(max-width: 1024px)",
  desktop: "(min-width: 1025px)",
  tabletUp: "(min-width: 641px)",
} as const
